/* eslint-disable no-alert */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useState } from 'react';
import Pagination from 'material-ui-flat-pagination';
import { PostPushLog, SendRequestDto } from '../../../api/PushLogAPI';
import { NotificationHistoryInfo } from '../../../models/notificationHistoryInfo';
import {
  ERROR_MESSAGE_API,
  TITLE_TEXT,
  PUSH_LOG_INDEX_TEXT,
  SEND_STATUS_TEXT,
  SEND_DATETIME_TEXT,
} from '../../../util/Const';
import { Keyword, NotificationType } from './FormItem';
import { GetTimestamp, SendStatus } from '../GenericMethod';
import getBytes from '../../../util/StringUtil';

const NotificationHistoryIndex = (props: any) => {
  const { history, setSelectedHistory } = props;
  const [historyIndex, setHistoryIndex] = useState<NotificationHistoryInfo[]>(
    []
  );
  const [keyword, setKeyword] = useState<string>();
  const [device, setDevice] = useState<string>();
  const [numberHistories] = useState<Number>();
  const [type, setType] = useState<Number>();
  const [isDebug, setIsDebug] = useState<Number>();
  const [refreshKey, setRefreshKey] = useState(0);
  // 初期オフセット0
  const [offset, setOffset] = useState(0);
  // 1ページの最大表示
  const parPage = 10;

  const handleClickPagination = (currentOffset: any) => {
    setOffset(currentOffset);
    console.info(offset);
  };

  const request: SendRequestDto = {
    keyword,
    device,
    author: sessionStorage.getItem('name'),
    number_histories: numberHistories,
    type,
    is_debug: undefined,
  };

  const search = () => {
    if (keyword === '') {
      setKeyword(undefined);
    } else if (keyword !== undefined && getBytes(keyword) > 256) {
      alert('文字数が多すぎます。');
      return;
    }
    if (device === '') {
      setDevice(undefined);
    }
    if (type === -1) {
      setType(undefined);
    }
    if (isDebug === -1) {
      setIsDebug(undefined);
    }
    setOffset(0);
    setRefreshKey(refreshKey + 1);
  };

  useEffect(() => {
    const f = async () => {
      await PostPushLog(request)
        .then((response) => {
          const list: NotificationHistoryInfo[] = [];
          for (const historyItem of response.history) {
            const histories: NotificationHistoryInfo = {
              id: historyItem.id,
              timestamp: historyItem.timestamp,
              status: historyItem.status,
              succeedDevices: historyItem.succeed_devices,
              failedDevices: historyItem.failed_devices,
              title: historyItem.title,
              message: historyItem.message,
              author: historyItem.author,
              url: historyItem.url,
              devices: [],
              target: [],
              type: historyItem.type,
              isDebug: historyItem.is_debug,
            };
            if (historyItem.devices) {
              for (const deviceItem of historyItem.devices) {
                histories.devices.push(deviceItem);
              }
            }
            if (historyItem.target) {
              for (const targetItem of historyItem.target) {
                histories.target.push(targetItem);
              }
            }
            list.push(histories);
          }
          setHistoryIndex(list);
        })
        .catch(() => {
          alert(ERROR_MESSAGE_API);
        });
    };
    f();
  }, [refreshKey]);

  if (!history) {
    return null;
  }
  const indexItem = historyIndex
    .slice(offset, offset + parPage)
    .map((historyItem: NotificationHistoryInfo) => {
      return (
        <tr
          key={historyItem.id}
          className="index"
          onClick={() => setSelectedHistory(historyItem)}
        >
          <td className="title">{historyItem.title}</td>
          <td>{SendStatus(historyItem.status)}</td>
          {historyItem.timestamp ? (
            <td>{GetTimestamp(historyItem.timestamp)}</td>
          ) : (
            <td />
          )}
        </tr>
      );
    });

  return (
    <article id="history_index" className="rireki">
      <h1>{PUSH_LOG_INDEX_TEXT}</h1>
      <div>
        <dl>
          <Keyword keyword={keyword} setKeyword={setKeyword} />
          <NotificationType type={type} setType={setType} />
        </dl>
        <button type="button" className="btn" onClick={search}>
          検索
        </button>
      </div>
      <div className="tablearea">
        <table className="rirekiindex_table" cellSpacing="0" cellPadding="0">
          <tbody>
            <tr>
              <th scope="col" className="sticky">
                {TITLE_TEXT}
              </th>
              <th scope="col" className="sticky">
                {SEND_STATUS_TEXT}
              </th>
              <th scope="col" className="sticky">
                {SEND_DATETIME_TEXT}
              </th>
            </tr>
            {indexItem}
          </tbody>
        </table>
        {historyIndex.length > parPage && (
          <Pagination
            limit={parPage}
            offset={offset}
            total={historyIndex.length}
            onClick={(e, o) => handleClickPagination(o)}
          />
        )}
      </div>
    </article>
  );
};
export default NotificationHistoryIndex;
